import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../components/branding/Logo";
import { FULL_DISCLAIMER_PARAS } from "../lib/content";

/**
 * Static /disclaimer page. Copy is VERBATIM extended disclaimer from the
 * MeowMD source-of-truth — do not paraphrase.
 */
export default function Disclaimer() {
    return (
        <div className="meow-shell" data-testid="disclaimer-page">
            <header className="sticky top-0 z-20 flex items-center justify-between bg-meow-cream/95 px-5 py-4 backdrop-blur">
                <Link
                    to="/health-check"
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-[0_2px_10px_rgba(42,42,42,0.06)] hover:bg-white/90"
                    aria-label="Back"
                    data-testid="disclaimer-back-btn"
                >
                    <ArrowLeft className="h-4 w-4 text-meow-charcoal" strokeWidth={2} />
                </Link>
                <Logo />
                <span className="w-9" />
            </header>

            <main className="px-5 pb-16 pt-4">
                <span className="eyebrow">Legal</span>
                <h1
                    className="mt-2 font-display text-[2rem] font-medium leading-tight text-meow-charcoal"
                    data-testid="disclaimer-heading"
                >
                    Medical Disclaimer
                </h1>

                <div className="mt-6 space-y-4" data-testid="disclaimer-body">
                    {FULL_DISCLAIMER_PARAS.map((p, i) => (
                        <p
                            key={i}
                            className="text-[14.5px] leading-relaxed text-meow-charcoal/90"
                        >
                            {p}
                        </p>
                    ))}
                </div>

                <div className="mt-10">
                    <Link
                        to="/health-check"
                        className="meow-btn-secondary w-full"
                        data-testid="disclaimer-return-btn"
                    >
                        Back to the health check
                    </Link>
                </div>
            </main>
        </div>
    );
}
